import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import type { Report } from '../api/types';
import { ReportDetails } from './ReportDetails';

/**
 * Vollständige Detailansicht eines Berichts als Modal -- über einen Klick auf
 * den Berichtsnamen in der Liste geöffnet. Schließt über das ×, einen Klick
 * auf den abgedunkelten Hintergrund oder Escape. Über ein Portal direkt in
 * <body> gerendert (wie zuvor das Hover-Popup), damit es nicht vom
 * `overflow-x` der Tabellen-Scrollbox mit abgeschnitten wird.
 */
export function ReportDetailsModal({ report, onClose }: { report: Report; onClose: () => void }) {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  return createPortal(
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-box" onClick={(event) => event.stopPropagation()}>
        <button type="button" className="modal-close" aria-label="Schließen" onClick={onClose}>
          ×
        </button>
        <ReportDetails report={report} />
      </div>
    </div>,
    document.body,
  );
}
